import { ArrowRight, Users } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

const ResidencyProgram = () => {
    return (
        <section className="container mx-auto px-4 sm:px-6 py-8">
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

                {/* Left - Content */}
                <div className="flex-1 text-center lg:text-left">
                   

                    <h1 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-800 mb-3 leading-tight">
                      {' '}TACTOS   <span className="text-[#fd3e3d]">Residency Program</span>
                    </h1>

                     <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-sm font-medium mb-4">
                        <Users className="w-4 h-4" />
                        <span>India's first Startup Accelerator Program</span>
                    </div>

                    <p className="text-black/70 text-sm md:text-md mb-5 max-w-xl mx-auto lg:mx-0">
                        A premium 3-month on-site accelerator program designed to build
                        high-quality, investment-ready startups. Founders undergo
                        intense mentorship, product development, and fundraising
                        preparation. Only the best startups are admitted.
                    </p>

                    {/* <h2 className="text-[20px] font-bold text-gray-800 mb-3">
                        What is TACTOS Residency{' '}
                        <span className="text-[#fd3e3d]">Program?</span>
                    </h2>

                    <p className="text-black/70 text-xs mb-6 max-w-xl mx-auto lg:mx-0">
                        Startups spend 3 months living, working, building, and scaling
                        within a high-performance environment. Each cohort is designed
                        to produce startups with the “TACTOS Seal of Investment
                        Readiness.”
                    </p> */}

                    {/* CTA */}
                    <div className="flex justify-center lg:justify-start">
                        <Link
                            to="/instructions/residencypage"
                            className="group inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-3 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-[#fd3e3d]/25 hover:shadow-[#fd3e3d]/40"
                        >
                            Apply Now
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                    </div>
                </div>

                {/* Right - Image (hidden on mobile) */}
                <div className="flex-1 hidden lg:flex justify-center mt-4">
                    <img
                        src="/residencynew.png"
                        alt="Residency Program"
                        className="w-full max-w-md object-cover rounded-2xl max-h-[230px]"
                    />
                </div>

            </div>
        </section>
    )
}

export default ResidencyProgram
